<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <el-breadcrumb separator="/" class="page-breadcrumb">
        <el-breadcrumb-item>
          <div class="breadcrumb">
            <div class="left"></div>
            <div class="right">
              <h2>资金概览</h2>
              <!-- <router-link class="rebate-detail-link" to="/home/funds/rebate-detail">资金概览明细</router-link> -->
            </div>
          </div>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div class="page-actions">
        <div class="select">
          <!-- <div class="item">
            <div class="txt">用户UID</div>
            <div class="ipt">
              <el-input placeholder="用户UID" clearable v-model="userId">
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="txt">邀请人UID</div>
            <div class="ipt">
              <el-input placeholder="邀请人UID" clearable v-model="inviteBy">
              </el-input>
            </div>
          </div> -->
          <div class="item">
            <!-- <div class="txt">合伙人UID</div> -->
            <div class="ipt">
              <el-input placeholder="合伙人UID" clearable v-model="channelUserId" size="mini">
              </el-input>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">日期</div> -->
            <div class="ipt">
              <!-- <el-date-picker
      v-model="value1"
      type="datetimerange"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      :default-time="['12:00:00']">
    </el-date-picker> -->
              <el-date-picker v-model="value1" type="daterange" align="right" format="yyyy - MM - dd 日"
                value-format="yyyy-MM-dd" unlink-panels :clearable="false" range-separator="-" start-placeholder="开始日期"
                end-placeholder="结束日期" @change="changeTime($event)" :picker-options="pickerOptions" size="mini">
              </el-date-picker>
            </div>
          </div>
          <div class="item">
            <el-button size="mini" @click="searchYesterday">昨日</el-button>
          </div>
          <div class="item">
            <el-button size="mini" @click="searchToday">今日</el-button>
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch">查询</el-button>
          </div>
        </div>
      </div>
      <div style="margin:12px 0"><span>{{ spotText.coin }}: </span><el-select v-model="spotCoin" size="mini"><el-option v-for="coin in spotCoins" :key="coin" :value="coin" :label="coin" /></el-select></div>
      <user-list @refresh="refreshList" :value1="value1" :spot-coin="spotCoin"></user-list>
    </el-card>
    <!-- 添加用户信息弹框 -->
  </div>
</template>

<script>
import spotLabels from '@/components/spot-rebate/labels'
import { call as spotCall } from '@/components/spot-rebate/api'
import UserList from "./components/list";
import { mapState, mapActions, mapMutations } from "vuex";
import { QUERY_TYPE, PAGINATION } from "./constants";
import moment from "moment";

export default {
  name: "User",
  components: {
    UserList,
  },
  data() {
    return {
      spotCoin: "USDT", spotCoins: ["USDT"],
      value2: "",
      dialogVisible: false,
      userId: "",
      channelId: "",
      channelUserId: "",
      inviteBy: "",
      //  value1: '',
      value1: [
        moment().subtract(7, "days").format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD"),
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近半年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    spotText() { return spotLabels },
    ...mapState("funds", ["queryType", "queryTypeList", "pagination"]),
    ...mapState(["userInfo"]),
  },
  created() { spotCall(true, "/metadata").then(data => { this.spotCoins = data.coins.map(c => c.coin) }).catch(() => {}) },
  methods: {
    ...mapActions("funds", ["list", "addUser"]),
    ...mapMutations("funds", ["setQueryType", "setPagination"]),
    refreshList(data = {}) {
      this.list({
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",
        channelUserId: this.channelUserId,
        ...this.pagination,
        ...data,
      });
    },
    changeTime(e) {
      this.list({
        startTime: e[0],
        endTime: e[1],
        channelUserId: this.channelUserId,
        ...PAGINATION,
      });
    },
    searchYesterday() {
      this.value1 = [
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          "YYYY-MM-DD"
        ),
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          "YYYY-MM-DD"
        ),
      ];
      this.handleSearch();
    },
    searchToday() {
      const today = moment().format("YYYY-MM-DD");
      this.value1 = [today, today];
      this.handleSearch();
    },
    handleSearch() {
      this.list({
        startTime: this.value1 ? this.value1[0] : "",
        endTime: this.value1 ? this.value1[1] : "",

        channelUserId: this.channelUserId,

        ...PAGINATION,
      });
    },
    handleSave() { },
    closeDialog() {
      this.dialogVisible = false;
    },
    onOpen() { },
    onClose() {
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
    close() {
      // this.$emit("update:visible", false);
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
  },
  created() {
    console.log("sssssssssssss");
    this.list({
      startTime: this.value1 ? this.value1[0] : "",
      endTime: this.value1 ? this.value1[1] : "",
      channelUserId: this.channelUserId,
      ...PAGINATION,
    });
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
<style scoped>
.right {
  display: flex;
  align-items: baseline;
  gap: 16px;
}

.rebate-detail-link {
  font-size: 14px;
  font-weight: normal;
}
</style>
